export default __webpack_public_path__ + "static/media/typing.b12c170c.svg";